export * from "./auth"
export * from "./client"
export * from "./consent"
export * from "./debt"
export * from "./dialog"
export * from "./notice"
export * from "./payment_schedule"
export * from "./payment"
export * from "./refinance"
export * from "./sign"
export * from "./tawk"
export * from "./subscription"
export * from "./issue"
export * from "./help"

if (!process.env.REACT_APP_API_URL) {
  throw new Error("REACT_APP_API_URL must be set")
}
export const API_URL = process.env.REACT_APP_API_URL

if (!process.env.REACT_APP_INSTANCE) {
  throw new Error("REACT_APP_INSTANCE must be set")
}
export const INSTANCE = process.env.REACT_APP_INSTANCE

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
export const SENTRY_ENVIRONMENT =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || "testing"
export const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE
export const SENTRY_TRACES_SAMPLE_RATE =
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0"

export const GOOGLE_TRACKING_ID = process.env.GOOGLE_TRACKING_ID

export const NODE_ENV = process.env.NODE_ENV

export const POLLING_INTERVAL = 5000
export const POLLING_TIMEOUT = 60000

export const ACTION_STATUS_PENDING = "pending"
export const ACTION_STATUS_SUCCESS = "success"
export const ACTION_STATUS_CREATED = "created"
export const ACTION_STATUS_FAILED = "failed"

export const AVAILABLE_LOCALES = ["en", "et", "ru", "fi", "se", "lv", "lt"]
if (!process.env.REACT_APP_DEFAULT_LOCALE) {
  throw new Error("REACT_APP_DEFAULT_LOCALE must be set")
}
export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE

export const MONEY_TYPE = "money"
export const DATE_TYPE = "date"
export const STRING_TYPE = "string"
export const STRING_STRONG_TYPE = "strong"
export const STRING_CENTER_TYPE = "center"
export const STRING_TRUNCATED_TYPE = "truncated"
export const LINK_TYPE = "link"
